module.exports = __webpack_public_path__ + "static/media/110.90e84034.png";